import { modifier } from 'ember-modifier';

import { fns } from 'rise-ui/utils/function.js';

export default modifier((element, [ onDrag, onMove, onDrop ]) => {
  [ onDrag, onMove, onDrop ] = fns(onDrag, onMove, onDrop);

  let pointerId;

  function removeEvents() {
    if (pointerId) {
      element.releasePointerCapture(pointerId);
      pointerId = null;
    }
    element.removeEventListener('pointermove', handleMove);
    element.removeEventListener('pointerup', handleDrop);
    element.removeEventListener('pointercancel', handleCancel);
    element.removeEventListener('contextmenu', handleCancel);
  }

  function onCancel(event) {
    removeEvents();
    onDrop(event, true);
  }

  function handleCancel(event) {
    onCancel(event);
  }

  function handleDrag(event) {
    if (!event.isPrimary) {
      return;
    }

    element.setPointerCapture(pointerId = event.pointerId);
    element.addEventListener('pointermove', handleMove);
    element.addEventListener('pointerup', handleDrop);
    element.addEventListener('pointercancel', handleCancel);
    element.addEventListener('contextmenu', handleCancel);

    onDrag(event, () => { onCancel(event) });
  }

  function handleMove(event) {
    onMove(event, () => { onCancel(event) });
  }

  function handleDrop(event) {
    removeEvents();
    onDrop(event, false);
  }

  element.style.touchAction = 'none';
  element.addEventListener('pointerdown', handleDrag);

  return () => {
    element.removeEventListener('pointerdown', handleDrag);
    removeEvents();
    element.style.touchAction = '';
  };
});
